export default __webpack_public_path__ + "static/media/right6.9331d402.png";